import {BaseOptions} from "../../../../dialog/options/base.options";

export class AttributeSelectorOptions extends BaseOptions {
  attributeList?: any[];
  onAttributeSelected = (attributes: any[]) => {
  };
}
